import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmDialog from "components/confirm-dialog";
import useToggle from "hooks/useToggle";
import { toast } from "react-toastify";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";
import { reactivateSubscription } from "actions/account/subscription";
import { subscriptionReviewUrl } from "utils/constants";
import navigate from "helpers/navigate";
import useReactivationFlow from "hooks/useReactivationFlow";
import { trackReactivateSubscription } from "services/analytics";

const ReactivateSubscription = ({ className = "", buttonText = "" }) => {
	const { translation } = useGlobalContext();
	const [isModalOpen, toggleModal] = useToggle();
	const dispatch = useDispatch();
	const { updateReactivationFlow } = useReactivationFlow();
	const { subscriptionId, isCancelled } = useSelector((state) => state.account.subscription);

	const resumeTranslation = translation?.subscription?.resume;

	const resume = async () => {
		const response = await dispatch(reactivateSubscription());
		if (response.success) {
			trackReactivateSubscription(subscriptionId);
			toast.success(response?.message || "Subscription resumed successfully");
			if (isCancelled) {
				navigate(subscriptionReviewUrl);
				updateReactivationFlow({ step: 1 });
			}
		} else {
			toast.error(response?.message || "Something went wrong");
		}
	};

	return (
		<>
			<ConfirmDialog
				title={resumeTranslation?.dialog?.title}
				description={resumeTranslation?.dialog?.description}
				confirmText={resumeTranslation?.dialog?.button}
				isOpen={isModalOpen}
				setIsOpen={toggleModal}
				callback={resume}
			/>
			<button
				className={clsx("px-3 min-w-40 py-2 btn-primary normal-case tracking-normal", className)}
				onClick={toggleModal}
			>
				{buttonText || resumeTranslation?.button || "Resume"}
			</button>
		</>
	);
};

export default ReactivateSubscription;